import { Tooltip } from 'antd';
import React, { useState, useEffect, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { connect, useDispatch } from 'react-redux';

import { getOpenedTaskId } from '../../../../../redux/general/selectors.js';
import { editTaskAction } from '../../../../../redux/tasks/actions.js';
import { getOpenedTaskTitle } from '../../../../../redux/tasks/taskEntities/selectors.js';

import './EditableTaskDetailTitleStyles.css';

const EditableTaskDetailTitle = ({ taskId, taskTitle }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const [titleValue, setTitleValue] = useState(taskTitle);

  useEffect(() => {
    setTitleValue(taskTitle);
  }, [taskTitle]);

  const handleTitleValueChange = useCallback((e) => setTitleValue(e.target.value), [])

  const submitTaskTitleChange = useCallback(() => {
    if (titleValue.trim().length <= 0) {
      setTitleValue(taskTitle);
      return;
    }

    if (taskTitle === titleValue) {
      return;
    }

    dispatch(editTaskAction({
      _id: taskId,
      taskTitle: titleValue,
    }, null, () => {}));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId, taskTitle, titleValue]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      submitTaskTitleChange();
    }
  }, [submitTaskTitleChange])

  return (
    <div className="task-detail-title-wrapper">
      <div className="task-detail-title-shadow">
        {titleValue + ' '}
      </div>
      <Tooltip
        title={intl.formatMessage({
          id: 'CLICK_TO_EDIT',
          defaultMessage: 'Click to edit',
        })}
      >
        <textarea
          className="task-detail-title"
          onBlur={submitTaskTitleChange}
          onChange={handleTitleValueChange}
          onKeyDown={handleKeyDown}
          value={titleValue}
        />
      </Tooltip>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    taskId: getOpenedTaskId(state),
    taskTitle: getOpenedTaskTitle(state),
  };
}

export default connect(mapStateToProps)(EditableTaskDetailTitle);
